import { z } from "zod";
import { ShortText, OrdinalBand, CountermeasureStatus, idString, } from "./common.js";
export const COUNTERMEASURE_TABLE_MAX_ROWS = 100;
export const CountermeasureRowSchema = z
    .object({
    id: idString,
    title: ShortText,
    owner: ShortText,
    /** The tenant member `owner` names, when picked from the people picker. */
    ownerUserId: z.string().uuid().nullable().optional(),
    impact: OrdinalBand,
    effort: OrdinalBand,
    window: ShortText,
    status: CountermeasureStatus,
})
    .strict();
/** AI input: no row id, and no person link — a model writes the owner's name only. */
export const CountermeasureRowInputSchema = CountermeasureRowSchema.omit({
    id: true,
    ownerUserId: true,
});
/**
 * Countermeasure Table — Verify, singleton. Ordinal-banded scoring
 * (Low / Med / High) for impact + effort, plus status pill cycling
 * through Proposed → Approved → In Design → Trial → Done.
 */
export const CountermeasureTableParamsSchema = z
    .object({
    rows: z.array(CountermeasureRowSchema).max(COUNTERMEASURE_TABLE_MAX_ROWS),
})
    .strict();
export const defaultCountermeasureTableParams = {
    rows: [],
};
//# sourceMappingURL=countermeasureTable.js.map